import { render, staticRenderFns } from "./publicProp.vue?vue&type=template&id=7a75fb21&scoped=true&"
import script from "./publicProp.vue?vue&type=script&lang=ts&"
export * from "./publicProp.vue?vue&type=script&lang=ts&"
import style0 from "./publicProp.vue?vue&type=style&index=0&id=7a75fb21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a75fb21",
  null
  
)

export default component.exports